import {
  all,
  put,
  select,
  takeLatest,
  takeEvery,
  take,
} from "redux-saga/effects";
import {
  goToUpgradePage,
  logInNeeded,
} from "@/sagas/normalizers/errorNormalizer";
import { types as modalsAnchorActions } from "@/bit/reducers/reducers.modals-reducer";
import { types as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { types as orionActions } from "@/reducers/orion";
import { types as managerActions } from "@/reducers/manager";
import { types as clientActions } from "@/reducers/client";
import { types as productActions } from "@/reducers/product";
import { types as oneClickActions } from "@/reducers/oneClick";

import {
  initAnchorModalListener,
  addModal,
} from "@/bit/sagas/sagas.modals-saga";
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from "@/bit/sagas/sagas.main-saga";
import sessionExpired from "@gcloud-npm/utils.page.send-to-expired";
import { getClientData, getEmailMPlus, getEmailsMPlus } from "@/sagas/client";
import {
  getObd,
  getCompleteOBD,
  generatePin,
  validatePin,
  checkObd,
  redirect,
} from "@/sagas/manager";

import {
  types as initTypes,
  actions as actionsInitPage,
} from "@/reducers/initPage";
import { types as userTypes } from "@/reducers/user";
import { types as usageTypes } from "../reducers/usages";
import { types as catalogTypes } from "@/reducers/catalogue";
import { types as tvTypes } from "@/reducers/tv";
import { types as consentsTypes } from "@/reducers/consents";
import { types as thirdPartiesTypes } from "@/reducers/thirdParties";
import { types as billsTypes } from "@/reducers/bills";
import { types as notiticationsTypes } from "@/reducers/notifications";
import { types as trackingTypes } from "@/reducers/tracking";
import { types as breackdownTypes } from "@/reducers/breakdown";
import { types as selfDiagnosisTypes } from "@/reducers/selfDiagnosis";
import { types as clientTypes } from "@/reducers/client";
import { types as contractsTypes } from "@/reducers/contracts";
import { types as prepaidTypes } from "@/reducers/prepaid";
import { types as miscellanyTypes } from "@/reducers/miscellany";
import { types as deviceListTypes } from "@/reducers/device-list";
import { types as addressTypes } from "@/reducers/address";
import { types as cerberusTypes } from "@/reducers/cerberus";
import * as userSagas from "@/sagas/user";
import * as initPage from "@/sagas/initPage";
import * as productSagas from "@/sagas/product/index.js";
import * as usagesSagas from "./usages";
import * as catalogSagas from "@/sagas/catalogue";
import * as orionSagas from "@/sagas/orion";
import * as tvSagas from "@/sagas/tv";
import * as thirdPartiesSagas from "@/sagas/thirdParties";
import * as billsSagas from "@/sagas/bills/index.js";
import * as notifiactionsSagas from "@/sagas/notifications";
import * as selfDiagnosisSagas from "@/sagas/selfDiagnosis/index";
import * as trackingSagas from "@/sagas/tracking/index.js";
import * as breakdownSagas from "@/sagas/breakdown";
import * as clientSagas from "@/sagas/client";
import * as contractsSagas from "@/sagas/contracts";
import * as miscellanySagas from "@/sagas/miscellany";
import * as prepaidSagas from "@/sagas/prepaid/index.js";
import * as oneClickSagas from "@/sagas/one-click";
import * as deviceListSagas from "@/sagas/device-list";
import * as addressSagas from "@/sagas/address";
import * as tvModules from "@/sagas/tv/index";
import * as consentsSagas from "@/sagas/consents";
import * as cerberusSagas from "@/sagas/cerberus";

import { enviromentKey, handlingCodes } from "@/constants/constants";
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";

function* rootSaga() {
  yield all([
    takeLatest(initTypes.INIT_PAGE, initPage.initPage),
    takeLatest(userTypes.USER_INIT, userSagas.initializeUser),
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    // //cp
    // takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    //orion
    takeEvery(
      orionActions.GET_ORION_INFO_DATA_BEGINS,
      orionSagas.getOrionInfoData
    ),
    takeEvery(
      orionActions.GET_ORION_PRODUCT_CHRACTERISTICS_BEGINS,
      orionSagas.getOrionProductCharacteristics
    ),
    // OBD
    takeLatest(managerActions.GET_OBD_BEGINS, getObd),
    takeLatest(managerActions.GET_OBD_COMPLETE_BEGINS, getCompleteOBD),
    // GENERATE PIN
    takeLatest(managerActions.GENERATE_PIN_BEGINS, generatePin),
    // vALIDATE PIN
    takeLatest(managerActions.VALIDATE_PIN_BEGINS, validatePin),
    // CHECK OBD
    takeLatest(managerActions.CHECK_OBD_BEGINS, checkObd),
    //clientInfo
    takeLatest(clientActions.GET_CLIENT_DATA_BEGINS, getClientData),
    //usages
    takeLatest(usageTypes.GET_MY_USAGES, usagesSagas.getMyUsages),
    takeEvery(
      usageTypes.GET_DETAILED_USAGES_BY_TYPE_BEGINS,
      usagesSagas.getDetailedUsagesByType
    ),
    takeLatest(
      usageTypes.GET_ALL_ACCUMULATED_USAGES,
      usagesSagas.getAllAccumulatedUsagesData
    ),
    //product
    takeLatest(
      productActions.GET_MY_PRODUCTS_BEGINS,
      productSagas.getMyProductsData
    ),
    //product
    takeLatest(
      productActions.GET_MY_PRODUCTS_WITHOUT_CACHE_BEGINS,
      productSagas.getMyProductsDataWithoutCache
    ),
    takeLatest(
      productActions.GET_MOBILE_CONFIGURATION_STATUS_BEGINS,
      productSagas.getMobileConfigurationStatusData
    ),
    takeLatest(
      productActions.CHANGE_MOBILE_CONFIGURATION_BEGINS,
      productSagas.changeMobileConfigurationData
    ),
    takeEvery(
      productActions.CHANGE_MOBILE_RESTRICTION_BEGINS,
      productSagas.changeMobileRestrictionData
    ),
    takeEvery(
      productActions.CHANGE_MOBILE_RESTRICTION_GESTION_BEGINS,
      productSagas.changeMobileRestrictionDataForGestions
    ),
    takeLatest(
      productActions.GET_MOBILE_RESTRICTION_STATUS_BEGINS,
      productSagas.getMobileRestrictionStatusData
    ),
    takeLatest(productActions.GET_PUK_CODE_BEGINS, productSagas.getPukByLine),
    //get PUK

    //FOR GESTIONS
    takeLatest(
      productActions.GET_MOBILE_RESTRICTION_GESTION_STATUS_BEGINS,
      productSagas.getMobileRestrictionStatusDataForGestions
    ),
    takeEvery(
      productActions.GET_EQUIPMENT_PRODUCTS,
      productSagas.getEquipmentProducts
    ),
    takeEvery(
      productActions.GET_MIS_PRODUCTOS_R2R_BEGINS,
      productSagas.myProductRenttorent
    ),
    takeLatest(
      productActions.GET_ACTIVATE_LINE_BEGINS,
      productSagas.getActivateLineData
    ),
    takeEvery(
      productActions.GET_ALL_PRODUCTOS_R2R_BEGINS,
      productSagas.getAllMyProductsR2R
    ),
    //catalog
    takeEvery(
      catalogTypes.GET_CATALOGUE_PRODUCT_OFFERING_BEGINS,
      catalogSagas.getCatalogueProductOffering
    ),
    takeEvery(
      catalogTypes.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_BEGINS,
      catalogSagas.getCatalogueProductOfferingAttachments
    ),
    //tv
    takeEvery(
      tvTypes.GET_MOVISTAR_LITE_ACTIVATION_BEGINS,
      tvSagas.getMovistarLiteActivation
    ),
    takeLatest(
      tvTypes.GET_MOVISTAR_LITE_STATUS_BEGINS,
      tvSagas.getMovistarLiteStatus
    ),
    takeLatest(tvTypes.GET_TV_PACKAGES_INFO_BEGINS, tvSagas.getTvPackagesInfo),
    takeLatest(
      thirdPartiesTypes.GET_DISNEY_COMPATIBILITY,
      thirdPartiesSagas.getCompatibilityDisneyData
    ),
    takeLatest(
      thirdPartiesTypes.GET_DISNEY_ACTIVATION,
      thirdPartiesSagas.getDisneyActivation
    ),
    takeLatest(
      thirdPartiesTypes.GET_GAME_PASS_CODE,
      thirdPartiesSagas.getGamePassActivationCodeData
    ),
    takeEvery(
      thirdPartiesTypes.GET_PROVIDER_COMPATIBILITY_BEGINS,
      thirdPartiesSagas.getProviderCompatibility
    ),
    takeEvery(
      thirdPartiesTypes.GET_NEW_PROVIDER_COMPATIBILITY_BEGINS,
      thirdPartiesSagas.getNewProviderCompatibility
    ),
    takeLatest(
      thirdPartiesTypes.GET_PROVIDER_STATUS_BEGINS,
      thirdPartiesSagas.getProviderStatus
    ),
    takeLatest(
      thirdPartiesTypes.GET_NETFLIX_BEGINS,
      thirdPartiesSagas.getUrlActivateNetflix
    ),
    takeLatest(
      thirdPartiesTypes.GET_URL_ALEJANDRA_BEGINS,
      thirdPartiesSagas.getUrlAlejandra
    ),
    takeLatest(
      thirdPartiesTypes.GET_SMART_WIFI_DEVICES_BEGINS,
      thirdPartiesSagas.getDevicesConnectedSmartWiFi
    ),
    takeLatest(
      thirdPartiesTypes.GET_SMART_WIFI_OTHERS_DETAILS_BEGINS,
      thirdPartiesSagas.getOthersDetailsSmartWiFi
    ),
    takeLatest(
      thirdPartiesTypes.SMART_WIFI_MANAGEMENT_BEGINS,
      thirdPartiesSagas.managementSmartWiFi
    ),
    takeLatest(
      thirdPartiesTypes.GET_PROMO_CODES,
      thirdPartiesSagas.getPromotionalCode
    ),
    //bills
    takeLatest(billsTypes.GET_BILLS_BEGINS, billsSagas.getMyBills),
    takeLatest(billsTypes.GET_BILLS_CLAIMS_BEGINS, billsSagas.getBillsClaimsData),
    takeLatest(billsTypes.GET_BILL_DETAILS_BEGINS, billsSagas.getBillDetails),
    takeEvery(billsTypes.GET_BILL_DOWNLOAD_BEGINS, billsSagas.getBillDownload),
    takeLatest(billsTypes.POST_ECO_BILL_BEGIN, billsSagas.postEcoBill),
    takeEvery(billsTypes.GET_BILL_ADDRESS_BEGINS, billsSagas.getBillAddress),
    takeLatest(billsTypes.MODIFY_BILL_ADDRESS_BEGIN, billsSagas.modifyBillAddress),
    takeEvery(billsTypes.GET_CLAIM_DETAILS, billsSagas.getClaimDetails),
    //restrictions
    takeLatest(
      productActions.GET_MY_LINE_DETAIL_MOBILE_RESTRICTION_STATUS_BEGINS,
      productSagas.getMyLineDetailMobileRestrictionStatusData
    ),
    takeLatest(managerActions.REDIRECT, redirect),
    takeLatest(clientActions.GET_EMAIL_MOVISTAR_PLUS_BEGINS, getEmailMPlus),
    takeLatest(clientActions.GET_EMAILS_MOVISTAR_PLUS_BEGINS, getEmailsMPlus),
    takeLatest(
      productActions.POST_SEGUNDA_FIBRA_ACTIVAR_BEGINS,
      productSagas.postActivarSegundaFibra
    ),
    takeLatest(
      productActions.POST_SEGUNDA_FIBRA_DESACTIVAR_BEGINS,
      productSagas.postDesactivarSegundaFibra
    ),
    takeLatest(
      productActions.GET_SELLING_TYPES_BY_PRODUCT_ID_BEGIN,
      productSagas.getSellingTypesByProductIds
    ),
    // notifiactions
    takeLatest(
      notiticationsTypes.GET_NOTIFICATIONS,
      notifiactionsSagas.getNotificationsData
    ),
    //tracking
    takeLatest(
      trackingTypes.GET_LIST_TRACKING_BEGINS,
      trackingSagas.getListTracking
    ),
    takeLatest(
      trackingTypes.GET_DETAIL_TRACKING_BEGINS,
      trackingSagas.getDetailTracking
    ),
    takeLatest(
      trackingTypes.GET_SLOTS_TRACKING_BEGINS,
      trackingSagas.getSlotsTracking
    ),
    takeLatest(
      trackingTypes.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS,
      trackingSagas.postModifyAppointment
    ),
    takeLatest(
      trackingTypes.POST_CREATE_APPOINTMENT_TRACKING_BEGINS,
      trackingSagas.postCreateAppointment
    ),
    takeLatest(trackingTypes.GET_CELERIS_INFO, trackingSagas.getCelerisInfo),
    //breackdown
    takeLatest(
      breackdownTypes.BREAKDOWN_TRACKING,
      breakdownSagas.getBreakdownTracking
    ),
    //selfDiagnosis
    takeLatest(
      selfDiagnosisTypes.OPEN_DIAGNOSIS_BEGINS,
      selfDiagnosisSagas.openDiagnosis
    ),
    takeLatest(
      selfDiagnosisTypes.GET_REASON_BEGINS,
      selfDiagnosisSagas.getReason
    ),
    takeLatest(
      selfDiagnosisTypes.GET_DIAGNOSIS_STATUS_BEGINS,
      selfDiagnosisSagas.getDiagnosisState
    ),
    takeLatest(
      selfDiagnosisTypes.SEND_INFO_TO_DIAGNOSIS,
      selfDiagnosisSagas.sendInfoToDiagnosis
    ),
    takeLatest(
      selfDiagnosisTypes.PUT_CONTINUE_DIAGNOSIS_BEGIN,
      selfDiagnosisSagas.putContinueDiagnosis
    ),
    takeLatest(
      selfDiagnosisTypes.PUT_REITERATE_DIAGNOSIS_BEGIN,
      selfDiagnosisSagas.putReiterateDiagnosis
    ),
    takeLatest(
      selfDiagnosisTypes.PUT_VALIDATE_DIAGNOSIS_BEGIN,
      selfDiagnosisSagas.putValidateDiagnosis
    ),
    takeLatest(
      selfDiagnosisTypes.PUT_CANCEL_DIAGNOSIS_BEGIN,
      selfDiagnosisSagas.putCancelDiagnosis
    ),
    //client
    takeLatest(
      clientTypes.GET_DEBT_PAYMENT_BEGIN,
      clientSagas.getDebtPaymentData
    ),
    takeEvery(
      clientTypes.POST_MODIFY_CONTACT_MEANS_BEGIN,
      clientSagas.postModifyContactMeans
    ),
    takeLatest(
      clientTypes.CHANGE_PASSWORD_BEGINS,
      clientSagas.changePassword
    ),
    // contracts
    takeEvery(
      contractsTypes.GET_LIST_CONTRACTS_BY_ID_BEGINS,
      contractsSagas.getListContractsById
    ),
    // prepaid
    takeLatest(
      prepaidTypes.RECHARGE_PREPAID_BEGINS,
      prepaidSagas.getRechargePrepaid
    ),
    takeLatest(
      prepaidTypes.GET_BALANCE_PREPAID_BEGINS,
      prepaidSagas.getBalancePrepaid
    ),
    takeLatest(
      prepaidTypes.GET_ACCUMULATED_USAGE_PREPAID_BEGINS,
      prepaidSagas.getAccumulatedUsagesPrepaid
    ),
    takeLatest(
      prepaidTypes.GET_DETAILS_USAGE_PREPAID_BEGINS,
      prepaidSagas.getDetailsUsagesPrepaid
    ),
    takeEvery(
      prepaidTypes.GET_TARIF_DETAIL_PREPAID_BEGINS,
      prepaidSagas.getTarifDetailsPrepaid
    ),
    // orderDetails
    takeEvery(
      trackingTypes.ORDER_DETAILS_TRACKING_BEGINS,
      trackingSagas.getOrderDetails
    ),
    // miscellany get urp tp
    takeLatest(
      miscellanyTypes.MISCELLANY_URL_TP_BEGINS,
      miscellanySagas.getUrlTp
    ),
    // oneClick
    takeLatest(
      oneClickActions.CREATE_ONE_CLICK_CQ_BEGIN,
      oneClickSagas.createOneClickCQ
    ),
    takeLatest(
      oneClickActions.CONFIRM_ONE_CLICK_CQ_BEGIN,
      oneClickSagas.confirmOneClickCQ
    ),
    takeLatest(
      oneClickActions.DELETE_SERVICE_BY_EXPRESS_ORDER_BEGIN,
      oneClickSagas.deleteServiceByExpressOrder
    ),
    takeLatest(
      productActions.GET_ESIM_STATUS_BEGINS,
      productSagas.getEsimStatus
    ),
    takeLatest(
      productActions.SET_ESIM_STATUS_BEGINS,
      productSagas.setEsimStatus
    ),
    takeLatest(
      productActions.GET_ESIM_DOWNLOAD_BEGINS,
      productSagas.getEsimDownload
    ),
    // cross selling
    takeLatest(
      deviceListTypes.GET_DEVICES_INIT,
      deviceListSagas.getAllItem
    ),
    // notifications

    // address
    takeLatest(
      addressTypes.GET_HORIZONTAL_ADDRESSES,
      addressSagas.getHorizontalAddress
    ),
    takeLatest(
      addressTypes.GET_VERTICAL_ADDRESSES,
      addressSagas.getVerticalAddress
    ),
    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga
    ),
    // modules Tv
    takeLatest(
      tvTypes.GET_MODULES_TV_BEGINS,
      tvModules.getModulesTv
    ),
    // upgrade equipment
    takeLatest(
      productActions.SET_UPGRADE_EQUIPMENT_BEGIN,
      productSagas.getUpgradeEquipment
    ),
    // CONSENTS
    takeLatest(
      consentsTypes.GET_CONSENTS,
      consentsSagas.getClientConsents
    ),
    takeEvery(
      consentsTypes.SAVE_CONSENTS,
      consentsSagas.saveClientConsents
    ),
    //FTTR info
    takeLatest(
      productActions.GET_FTTR_PRODUCT_R2R_INFO_BEGIN,
      productSagas.getFTTRProductRenttorentInfo
    ),
    // Cerberus
    takeLatest(
      cerberusTypes.CERBERUS_GET_INFO,
      cerberusSagas.getInfoCerberus
    ),
    takeLatest(
      cerberusTypes.CERBERUS_GET_SUMMARY_INFO,
      cerberusSagas.getSummaryInfoCerberusWithDate
    ),
    takeLatest(
      cerberusTypes.PHONE_CALLS_IDENTIFIER_SWICTH_STATE_BEGIN,
      cerberusSagas.phoneCallsIdentifierSwitchState
    ),
    takeLatest(
      cerberusTypes.SPAM_CALLS_BLOCKING_SWICTH_STATE_BEGIN,
      cerberusSagas.spamCallsBlockingSwitchState
    ),
    takeLatest(
      cerberusTypes.FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_BEGIN,
      cerberusSagas.fraudulentSMSBlockingSwitchState
    ),
  ]);
}

const locationStore = (state) => state.initPage.location;

const normalizeErrors = (error) => {
  let errorCode = 999;
  if (error.status) {
    errorCode = error.status;
  } else if (error.response && error.response.status) {
    errorCode = error.response.status;
  }

  if (`${errorCode}` === "999" && typeof error === "string") {
    const errorUpper = error.toUpperCase();
    const checkContainsError =
      errorUpper.includes("BACK-SEGURIDAD-002") ||
      errorUpper.includes("BACK-APIGW-001") ||
      errorUpper.includes("TCOL-ARQUITECTURA-020") ||
      errorUpper.includes("TCOL-ARQUITECTURA-005");
    if (checkContainsError) {
      return 401;
    }
  }
  return errorCode;
};

export function* handleSagaError(
  processName,
  error,
  kind,
  handlingCode,
  reducerFailureAction
) {
  const location = yield select(locationStore);
  // se tienen que añadir las siguientes rutas a futuro:
  // const upgradePages = [getUrl('extraDetails'), getUrl('myContracts'), getUrl('tokenizacionHireProductPage')];
  const upgradePages = [];
  const filePath = `${location.hash}${location.search}`;
  // yield put(
  //   mainActions.throwSonda({
  //     filePath,
  //     processName,
  //     error,
  //     kind,
  //   })
  // );

  let handlingCodeAux = handlingCode;
  let actualPageLoginRequired = false;

  const errorNormalize = normalizeErrors(error);

  switch (errorNormalize) {
    case 302:
      handlingCodeAux = handlingCodes.LOGIN;
      break;
    case 401:
      handlingCodeAux = handlingCodes.REDIRECT_TO_LOGIN;
      break;
    case 412:
      /* Esto es si es un titular light que accede a algo que no puede */
      for (let i = 0; i < upgradePages.length; i += 1) {
        if (location.hash.includes(upgradePages[i])) {
          actualPageLoginRequired = true;
        }
      }
      if (actualPageLoginRequired) {
        handlingCodeAux = handlingCodes.UPGRADE;
      }
      break;
    case 598:
      handlingCodeAux = handlingCodes.MAINTENANCE;
      break;
    default:
      break;
  }

  switch (handlingCodeAux) {
    // sesión caducada se necesita relogar
    case handlingCodes.LOGIN:
      logInNeeded();
      break;
    // pagina de upgrade
    case handlingCodes.UPGRADE:
      goToUpgradePage();
      break;
    case handlingCodes.REDIRECT_TO_LOGIN:
      sessionExpired({});
      break;
    case handlingCodes.FATAL:
      yield put(actionsInitPage.setError(handlingCodeAux));
      break;
    case handlingCodes.MAINTENANCE:
      yield put(actionsInitPage.setError(handlingCodeAux));
      break;
    default:
      break;
  }
  if (reducerFailureAction) {
    yield put(reducerFailureAction);
  }

  if (enviromentKey !== ENV_NAME.PROD) {
    console.warn(
      `%c Error en la SAGA '${processName}' desde la ruta '${filePath}'\n\n`,
      "background:#222;color:#bada55;font-size:18px",
      error
    );
  }
}

export default rootSaga;
